import React, { useRef } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import CustomScrollbar from '../../../Model/Share/Normal/CustomScrollbar';

export default function PointReasonInput(props) {
  const { value, setValue } = props;
  const { t } = useLanguage();

  const InputRef = useRef(null);

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleFocus() {

  }

  function handleBlur() {

  }

  return (
    <TopLevelWrapper>
      <InputWrapper>
        <Input
          ref={InputRef}
          placeholder={t('memberDetail.pointSaveModal.placeholderReason')}
          value={value || ''}
          onFocus={handleFocus}
          onChange={handleChange}
          onBlur={handleBlur}/>
        <ScrollbarOverlay>
          <CustomScrollbar
            direction='vertical'
            scrollRef={InputRef}
            thumbSize='auto'
            thumbThickness={2}
            trackOffset={0}
            trackColor='transparent' />
        </ScrollbarOverlay>
      </InputWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const InputWrapper = styled.div`
  position: relative;

  width: 100%;
`;

const Input = styled.textarea`
  padding: 4px 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.theme.text};
  background-color: ${props => props.theme.buttonFill};

  resize: none;

  &::placeholder {
    color: ${props => props.theme.subText};
    text-align: center;
  }

  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
  }

  transition: all 0.3s ease-in-out;
`;

const ScrollbarOverlay = styled.div`
  position: absolute;
  top: 3px;
  right: 5px;
  bottom: 8px;

  width: 2px;

  pointer-events: auto;
  z-index: 1;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;